import styled from "styled-components";

export const Container = styled.div``;

export const Header = styled.div`
  width: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  margin: 0 0 30px 0;
  & i {
    margin-right: 10px;
    cursor: pointer;
  }
`;

export const ContentWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
`;

export const AddressBox = styled.div`
  position: relative;
  background-color: #fff;
  border: 1px solid #ececec;
  border-radius: 15px;
  overflow: hidden;
  transition: 0.2s;
  -moz-transition: 0.2s;
  -webkit-transition: 0.2s;
  -o-transition: 0.2s;
  margin-bottom: 0.7rem;
  margin-right: 0.7rem;
  width: 50%;
  cursor: pointer;
  :hover {
    -webkit-box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.05);
    box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.05);
    border: 1px solid #bce3c9;
    transition: 0.2s;
    -moz-transition: 0.2s;
    -webkit-transition: 0.2s;
    -o-transition: 0.2s;
  }

  @media (max-width: 980px) {
    width: 100%;
  }

  @media (max-width: 1024px) {
    width: 100%;
  }

  .product-badges.product-badges-position {
    position: absolute;
    right: 0;
    top: 0px;
    z-index: 9;
    > span {
      display: inline-block;
      font-size: 12px;
      line-height: 1;
      border-radius: 0px 10px 0 20px;
      color: #fff;
      padding: 9px 20px 10px 20px;
      background-color: #f74b81;
    }
  }
`;

export const AddressContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 20px 20px 30px 20px;

  .address-info {
    font-size: 14px;
    color: #253d4e;

    & li:not(:last-child) {
      margin-bottom: 4px;
      img {
        margin-right: 8px;
        max-width: 16px;
      }
    }
  }
  .address-btn {
    display: flex;
    margin-top: 1rem;
    justify-content: space-between;

    & button {
      display: flex;
      justify-content: center;
      align-items: center;
      min-width: 3.2rem;
      height: 2.2rem;
      font-size: 15px;
      font-weight: 400;
      padding: 0;
      border-radius: 5px;
      word-break: keep-all;
      background-color: #fff;
      color: #253d4e;
      border: 1px solid #253d4e;
      :hover {
        background-color: #253d4e;
        color: #fff;
      }
    }

    .btn-select {
      border: none;
      background-color: #3bb77e;
      color: #fff;
      :hover {
        background-color: #fd7e14;
      }
    }

    .btn-select-basic {
      border: none;
      background-color: #3bb77e;
      color: #fff;
      padding: 0 10px;
      :hover {
        background-color: #f1c40f;
      }
    }

    .basic-btns {
      display: flex;
    }

    & button:not(:last-of-type) {
      margin-right: 10px;
    }
  }

  @media (max-width: 767px) {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;

    .address-btn {
      display: flex;
      justify-content: flex-end;
      > button {
        margin-top: 16px;
      }
    }
  }
`;
export const ContentRow = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const ContentCol = styled.div`
  width: 100%;
  height: auto;
  padding-right: 5%;
  padding-bottom: 1rem;
  padding-left: 5%;
  display: flex;
  align-items: center;

  .zipcode {
    width: 39%;
  }

  .btn {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0;
    width: 30%;
    height: 38px;
    margin-left: 1%;
    word-break: keep-all;
    border-radius: 10px;
  }

  @media (max-width: 960px) {
    width: 100%;
    border: 0;
    margin-right: 0;
  }

  & h6 {
    display: flex;
    align-items: center;
    width: 30%;
    font-weight: 400;
    margin-bottom: 10px;
  }

  & input {
    width: 70%;
    height: 2.3rem;
  }
`;
